// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../bindings/Emotion.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function AboutPage(props) {
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem 6rem",
    maxWidth: "680px",
    margin: "0 auto"
  });
  let sectionStyles = Emotion.Css.css({
    borderTop: `1px solid ` + Emotion.Utils.Color.border,
    padding: "2rem 0"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Overline.make, {
        children: "Masthead"
      }),
      JsxRuntime.jsx(Typography.Typography.Display.make, {
        size: "3xl",
        className: Emotion.Css.css({
          marginTop: "1rem"
        }),
        children: "About the journal"
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textSecondary,
          fontStyle: "italic",
          marginTop: "1.25rem"
        }),
        children: "A place to read entries in full, then sit down at the desk when it is time to write."
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx(Typography.Typography.Heading.make, {
            level: "h2",
            size: "2xl",
            children: "Reading"
          }),
          JsxRuntime.jsx(Typography.Typography.Body.make, {
            className: Emotion.Css.css({
              color: Emotion.Utils.Color.textSecondary
            }),
            children: "The catalog lists titles and synopses. Each piece has its own page. You do not need an account to read."
          })
        ],
        className: sectionStyles
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx(Typography.Typography.Heading.make, {
            level: "h2",
            size: "2xl",
            children: "Writing"
          }),
          JsxRuntime.jsx(Typography.Typography.Body.make, {
            className: Emotion.Css.css({
              color: Emotion.Utils.Color.textSecondary
            }),
            children: "The author desk is signed-in. Start a blank page or revise an existing entry, then save it back to the catalog."
          })
        ],
        className: sectionStyles
      }),
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx(Typography.Typography.Heading.make, {
            level: "h2",
            size: "2xl",
            children: "Colophon"
          }),
          JsxRuntime.jsx(Typography.Typography.Body.make, {
            className: Emotion.Css.css({
              color: Emotion.Utils.Color.textSecondary,
              margin: "0"
            }),
            children: "Set in Playfair Display and IBM Plex. Built with ReScript, Rspack, React, Relay, and Cosmonexus tokens."
          })
        ],
        className: sectionStyles
      })
    ],
    className: containerStyles
  });
}

let Typography$1;

let make = AboutPage;

export {
  Typography$1 as Typography,
  make,
}
/* Emotion Not a pure module */
